'use strict';

module.exports = (app) => app.factory('deliveryReceiptService', /* @ngInject */ function (httpService, apiConfig) {

	function exportUnpaidDeliveries(dueDate) {
		const uri = apiConfig.getBase('invoice', 'export', 'unpaid');
		uri.query.deadline = window.moment(dueDate).endOf('day').format('YYYY-MM-DD');
		return httpService.get(uri.toString(), {
			responseType: 'blob',
			transformResponse: function(data, headers) {
				const response = {};
				const header = headers();

				response.data = data;
				response.filename = header['content-disposition'].split('filename=')[1].replace(';').split('"').join('');
				response.contentType = header['content-type'];

				return response;
			}
		})
	}

	return {
		/**
		 * @return {(dueDate: string) => void}
		 */
		exportUnpaidDeliveries
	}

});
